import { OrganizacaoSimples } from "./organizacao.interface";
import { Secretaria } from "./secretaria.interface";
import { UnidadeSimples } from "./unidade.interface";
import { Usuario } from "./usuario.interface";

export class Medico implements Usuario {
  id?: string;
  primeiro_nome: string;
  sobrenome: string;
  idade: string | Date;
  endereco: string;
  cidade: string;
  estado: string;
  telefone: string;
  whatsapp?: string;
  name_instagram?: string;

  email: string;
  tipo_usuario: 'medico'; 
  url?: string;
  crm: string;
  cbo?: string;
  cns?: string;
  cns_tipo?: string;
  cns_validade?: Date;
  ativado: boolean;
  bloqueado: boolean;
  n_pacientes?: number;
  proxima_consulta?: any;
  maximo_cartoes?: number;
  cartoes_usados?: number;
  secretarias?: Array<Secretaria>
  orgs?: Array<OrganizacaoSimples>;
  unidades?: Array<UnidadeSimples>;

  constructor(medico: Medico) {
    this.id = medico.id;
    this.primeiro_nome = medico.primeiro_nome;
    this.sobrenome = medico.sobrenome;
    this.idade = medico.idade;
    this.endereco = medico.endereco;
    this.cidade = medico.cidade;
    this.estado = medico.estado;
    this.telefone = medico.telefone;
    this.whatsapp = medico.whatsapp;
    this.name_instagram = medico.name_instagram;
    this.crm = medico.crm;
    this.cbo = medico.cbo;
    this.cns = medico.cns;
    this.cns_tipo = medico.cns_tipo;
    this.cns_validade = medico.cns_validade;
    this.email = medico.email;
    this.tipo_usuario = 'medico';
    this.url = medico.url;
    this.ativado = medico.ativado;
    this.bloqueado = medico.bloqueado;
    this.n_pacientes = medico.n_pacientes;
    this.proxima_consulta = medico.proxima_consulta;
    this.maximo_cartoes = medico.maximo_cartoes;
    this.cartoes_usados = medico.cartoes_usados;
    this.secretarias = medico.secretarias;
    this.orgs = medico.orgs;
    this.unidades = medico.unidades;
  }

  static create(medico: {
    primeiro_nome: string,
    sobrenome: string,
    idade: string,
    endereco: string,
    cidade: string,
    estado: string,
    telefone: string,
    whatsapp?: string;
    name_instagram?: string;
    crm: string,
    cbo?: string,
    cns?: string;
    cns_tipo?: string
    cns_validade?: Date;
    email: string,
    ativado: boolean,
    bloqueado: boolean,
    maximo_cartoes: number
    orgs?: Array<OrganizacaoSimples>;
    unidades?: Array<UnidadeSimples>;
  }) {
    return {
      primeiro_nome: medico.primeiro_nome,
      sobrenome: medico.sobrenome,
      idade: medico.idade,
      endereco: medico.endereco,
      cidade: medico.cidade,
      estado: medico.estado,
      telefone: medico.telefone,
      whatsapp: medico.whatsapp,
      name_instagram: medico.name_instagram,
      crm: medico.crm,
      cbo: medico.cbo,
      cns: medico.cns,
      cns_tipo: medico.cns_tipo,
      cns_validade: medico.cns_validade,
      email: medico.email,
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'medico',
      n_pacientes: 0,
      maximo_cartoes: medico.maximo_cartoes,
      orgs: medico.orgs,
      unidades: medico.unidades
    };
  }

  static createEmpty() {
    return {
      primeiro_nome: '',
      sobrenome: '',
      idade: '',
      endereco: '',
      cidade: '',
      estado: '',
      telefone: '',
      whatsapp: '',
      name_instagram: '',
      crm: '',
      cbo: '',
      cns: '',
      cns_tipo: '',
      email: '',
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'medico',
      n_pacientes: 0,
      maximo_cartoes: 0,
      orgs: [],
      unidades: []
    } as Medico;
  }
}
